import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BarChart3, X } from 'lucide-react';
export function SlideResults() {
  const [imgError, setImgError] = useState(false);
  const [imgError2, setImgError2] = useState(false);
  const [expanded, setExpanded] = useState(false);
  return <div className="h-full w-full bg-[#FDF8F8] text-[#2D2926] p-8 md:p-12 flex flex-col relative" data-id="element-630">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-3" data-id="element-631">
        <div className="flex items-center gap-3 mb-1" data-id="element-632">
          <div className="w-8 h-[2px] bg-[#E60012]" data-id="element-633" />
          <span className="text-[#E60012] text-sm font-medium tracking-wide uppercase" data-id="element-634">
            Case Study — Takeda DDW Congress
          </span>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-[#2D2926] mb-1" data-id="element-635">
          Results: Main Menu & Sub Menu Overview
        </h2>
        <p className="text-[#E60012] text-sm" data-id="element-636">
          Snak™ Report — GI DDW Congress 2–5 May 2025
        </p>
      </motion.div>

      <motion.div className="flex-1 flex items-center justify-center min-h-0 cursor-pointer" initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} onClick={() => setExpanded(true)} data-id="element-637">
        <div className="rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-white w-full max-h-[42vh] relative group" data-id="element-638">
          {imgError ? <div className="flex flex-col items-center justify-center w-full h-64 text-gray-400" data-id="element-639">
              <BarChart3 className="w-12 h-12 mb-3 text-[#E60012]/40" data-id="element-640" />
              <p className="text-sm font-medium" data-id="element-641">Image could not be loaded</p>
            </div> : <img src="https://cdn.magicpatterns.com/uploads/oAgMS44xZHe6QuwYWfvndf/Screenshot_2026-02-12_at_09.48.10.png" alt="Takeda DDW Congress — Main Menu and Sub Menu Overview" className="w-full h-full object-contain" onError={() => setImgError(true)} data-id="element-642" />}
          <div className="absolute inset-0 bg-[#2D2926]/0 group-hover:bg-[#2D2926]/5 transition-colors flex items-center justify-center" data-id="element-643">
            <span className="opacity-0 group-hover:opacity-100 transition-opacity bg-[#2D2926] text-white text-sm font-medium px-4 py-2 rounded-full shadow-lg" data-id="element-644">
              Click to see GI Sub Menu detail →
            </span>
          </div>
        </div>
      </motion.div>

      <motion.p className="text-center text-xs text-[#E60012] mt-3 italic" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.6
    }} data-id="element-645">
        Click the image above to drill down into the GI Sub Menu results
      </motion.p>

      <AnimatePresence data-id="element-646">
        {expanded && <motion.div className="fixed inset-0 z-[60] bg-[#FDF8F8] flex flex-col p-8 md:p-12" initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.85
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 28
      }} data-id="element-647">
            <button onClick={e => {
          e.stopPropagation();
          setExpanded(false);
        }} className="absolute top-6 right-6 z-[70] w-12 h-12 rounded-full bg-[#2D2926] text-white flex items-center justify-center shadow-2xl hover:bg-[#E60012] transition-colors" aria-label="Close detail view" data-id="element-648">
              <X className="w-6 h-6" data-id="element-649" />
            </button>

            <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.15
        }} className="mb-4" data-id="element-650">
              <div className="flex items-center gap-3 mb-1" data-id="element-651">
                <div className="w-8 h-[2px] bg-[#E60012]" data-id="element-652" />
                <span className="text-[#E60012] text-sm font-medium tracking-wide uppercase" data-id="element-653">
                  Drill-Down — GI Sub Menu
                </span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-[#2D2926] mb-1" data-id="element-654">
                GI Sub Menu Overview
              </h2>
              <p className="text-[#E60012] text-sm" data-id="element-655">
                Popularity #1 — 39/82 arrived at this Cue™
              </p>
            </motion.div>

            <motion.div className="flex-1 flex items-center justify-center min-h-0" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.25
        }} data-id="element-656">
              <div className="rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-white max-h-full w-full" data-id="element-657">
                {imgError2 ? <div className="flex flex-col items-center justify-center w-full h-64 text-gray-400" data-id="element-658">
                    <BarChart3 className="w-12 h-12 mb-3 text-[#E60012]/40" data-id="element-659" />
                    <p className="text-sm font-medium" data-id="element-660">
                      Image could not be loaded
                    </p>
                  </div> : <img src="https://cdn.magicpatterns.com/uploads/8VMjxgm94CXa8uvvvpRYNe/Screenshot_2026-02-12_at_11.00.27.png" alt="GI Sub Menu Overview — Product details, Live Demonstration" className="w-full h-full object-contain" onError={() => setImgError2(true)} data-id="element-661" />}
              </div>
            </motion.div>

            <motion.p className="text-center text-xs text-[#E60012] mt-3 italic" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.5
        }} data-id="element-662">
              Click ✕ to return to the overview
            </motion.p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}